import React from 'react';
import { Twitter, Linkedin, Github, Mail } from 'lucide-react';
import { useUserAuth } from '../../context/userAuthContext';

// Traducciones para el Footer
const translations = {
  en: {
    description: "Transforming industries with advanced AI solutions and 3D printing technology for innovative companies.",
    products: {
      title: "Products",
      items: [
        { name: "FroniosCloud", url: "#" },
        { name: "FroniosPrint", url: "#" },
        { name: "FroniosGPT", url: "#" },
        { name: "Custom Solutions", url: "#" }
      ]
    },
    company: {
      title: "Company",
      items: [
        { name: "About Us", url: "#" },
        { name: "Careers", url: "#" },
        { name: "Blog", url: "#" },
        { name: "Contact", url: "#" }
      ]
    },
    resources: {
      title: "Resources",
      items: [
        { name: "Documentation", url: "#" },
        { name: "Support", url: "#" },
        { name: "API", url: "#" },
        { name: "Privacy Policy", url: "#" }
      ]
    },
    legal: {
      rights: "All rights reserved.",
      terms: "Terms",
      privacy: "Privacy",
      cookies: "Cookies"
    }
  },
  es: {
    description: "Transformando industrias con soluciones de IA avanzadas y tecnología de impresión 3D para empresas innovadoras.",
    products: {
      title: "Productos",
      items: [
        { name: "FroniosCloud", url: "#" },
        { name: "FroniosPrint", url: "#" },
        { name: "FroniosGPT", url: "#" },
        { name: "Soluciones a Medida", url: "#" }
      ]
    },
    company: {
      title: "Empresa",
      items: [
        { name: "Sobre Nosotros", url: "#" },
        { name: "Carreras", url: "#" },
        { name: "Blog", url: "#" },
        { name: "Contacto", url: "#" }
      ]
    },
    resources: {
      title: "Recursos",
      items: [
        { name: "Documentación", url: "#" },
        { name: "Soporte", url: "#" },
        { name: "API", url: "#" },
        { name: "Política de Privacidad", url: "#" }
      ]
    },
    legal: {
      rights: "Todos los derechos reservados.",
      terms: "Términos",
      privacy: "Privacidad",
      cookies: "Cookies"
    }
  }
};

const Footer = () => {
  const { currentLanguage } = useUserAuth();
  const t = translations[currentLanguage];

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-4 sm:px-8 md:px-16 lg:px-24 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          <div>
            {/* Logo con el texto fronios */}
            <div className="flex items-center mb-6">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/fronios-48861.firebasestorage.app/o/logos%2FScreenshot_2025-04-07_at_12.48.37_p.m.-removebg-preview.png?alt=media&token=2603b714-7c47-4d62-8f94-9efd5d7cbed0"
                alt="Fronios Logo"
                className="h-10 w-auto"
              />
              <span className="font-sans tracking-tight text-black ml-2">
                <span className="text-2xl font-light">fronios</span>
              </span>
            </div>
            <p className="text-gray-600">{t.description}</p>

            <div className="mt-8">
              <div className="flex space-x-4">
                <a href="#" className="p-2 bg-white border border-gray-200 hover:border-blue-500 rounded-sm transition-all shadow-sm hover:shadow">
                  <Twitter className="h-5 w-5 text-gray-500 hover:text-blue-500" />
                </a>
                <a href="#" className="p-2 bg-white border border-gray-200 hover:border-blue-500 rounded-sm transition-all shadow-sm hover:shadow">
                  <Linkedin className="h-5 w-5 text-gray-500 hover:text-blue-500" />
                </a>
                <a href="#" className="p-2 bg-white border border-gray-200 hover:border-blue-500 rounded-sm transition-all shadow-sm hover:shadow">
                  <Github className="h-5 w-5 text-gray-500 hover:text-blue-500" />
                </a>
                <a href="#" className="p-2 bg-white border border-gray-200 hover:border-blue-500 rounded-sm transition-all shadow-sm hover:shadow">
                  <Mail className="h-5 w-5 text-gray-500 hover:text-blue-500" />
                </a>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-gray-800 border-b border-blue-500 pb-2 inline-block">{t.products.title}</h4>
            <ul className="space-y-4">
              {t.products.items.map((item, index) => (
                <li key={index}>
                  <a href={item.url} className="text-gray-600 hover:text-blue-500 transition-colors">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-gray-800 border-b border-teal-500 pb-2 inline-block">{t.company.title}</h4>
            <ul className="space-y-4">
              {t.company.items.map((item, index) => (
                <li key={index}>
                  <a href={item.url} className="text-gray-600 hover:text-teal-500 transition-colors">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-6 text-gray-800 border-b border-orange-500 pb-2 inline-block">{t.resources.title}</h4>
            <ul className="space-y-4">
              {t.resources.items.map((item, index) => (
                <li key={index}>
                  <a href={item.url} className="text-gray-600 hover:text-orange-500 transition-colors">
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Fronios Technology. {t.legal.rights}
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-500 hover:text-blue-500 text-sm">{t.legal.terms}</a>
            <a href="#" className="text-gray-500 hover:text-blue-500 text-sm">{t.legal.privacy}</a>
            <a href="#" className="text-gray-500 hover:text-blue-500 text-sm">{t.legal.cookies}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;